import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { API } from "../config/api-config";
import { HttpService } from "../service/http-service";

declare var alertify: any;
@Component({
  selector: "app-goal-list",
  templateUrl: "./goal-list.component.html",
  styleUrls: ["./goal-list.component.css"],
})
export class GoalListComponent implements OnInit {
  constructor(private router: Router, private http: HttpService) {}

  public data: any = [];
  public imagePath: string = "";
  public pageData: object = {};
  public page = { pageNumber: 1 };

  ngOnInit() {
    this.getData();
    this.getPath();
  }

  private getPath(): void {
    this.http.getData(API.resourcePath).then((res) => {
      this.imagePath = res.data;
      this.getData();
    });
  }

  public getData(isSearch = false) {
    let data = { ...this.page };
    data.pageNumber--;

    this.http.getData(API.goalList, data).then((res) => {
      this.data = res.data;
      // this.pageData = res.data;
      // delete this.pageData["content"];
    });
  }

  public editGoal(id: number) {
    this.router.navigate(["index/goal", id]);
  }
  //
  public deleteGoal(id: number): void {
    let _self = this;
    alertify.confirm(
      "删除",
      "確定要刪除嗎？",
      function () {
        _self.http.deleteData(API.goalList + "/" + id).then((res) => {
          if (res.status.code == 0) {
            alertify.success(res.status.message);
            _self.getData();
          } else {
            alertify.error(res.status.message);
          }
        });
      },
      function () {}
    );
  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/goal-list/goal-list.component.ts